export default __webpack_public_path__ + "static/media/06-ART-(4-2).d85e66ac.jpg";